import { Injectable } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  CanActivate,
  CanDeactivate,
  Router,
  RouterStateSnapshot,
  UrlTree,
} from '@angular/router';
import { Observable } from 'rxjs';
import { AuthService } from '../services/auth.service';
import { HelpersService } from '../services/helpers.service';

@Injectable({
  providedIn: 'root',
})
export class AuthGuard implements CanActivate, CanDeactivate<unknown> {
  constructor(
    private auth: AuthService,
    private router: Router,
    private helpers: HelpersService,
  ) {}

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot,
  ): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    const currentRoles = this.auth.getLoggedUser().userRoles.map((item: any) => {return item.role.code});
    const roles = this.auth.getRoleFromToken().roles;
    if (!this.auth.isAuthenticated() || !this.auth.sameRole(currentRoles, roles)) {
      return this.ifNotAuthenticated(state, `Sesi Anda telah berakhir`);
    }
    return true;
  }

  ifNotAuthenticated(state: RouterStateSnapshot, msg: string): boolean {
    this.helpers.sbError(msg);
    this.auth.removeToken();
    this.router.navigate(['/login'], {
      queryParams: {
        url: state.url,
      },
    });
    return false;
  }

  canDeactivate(
    component: unknown,
    currentRoute: ActivatedRouteSnapshot,
    currentState: RouterStateSnapshot,
    nextState?: RouterStateSnapshot,
  ): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    return true;
  }
}
